import React from 'react';
import { Nav } from 'react-bootstrap';
import '../Sidebar.css';

const Sidebar = ({ isOpen }) => {
  return (
    <div className={`sidebar bg-dark text-white ${isOpen ? 'open' : 'collapsed'}`}>
      <Nav className="flex-column pt-3">
        <Nav.Link href="#" className="text-white">🏠 {isOpen && 'Home'}</Nav.Link>
        <Nav.Link href="#" className="text-white">📄 {isOpen && 'About'}</Nav.Link>
        <Nav.Link href="#" className="text-white">📧 {isOpen && 'Contact'}</Nav.Link>
        <Nav.Link href="#" className="text-white">⚙️ {isOpen && 'Settings'}</Nav.Link>
      </Nav>
    </div>
  );
};

export default Sidebar;